import React from 'react';
import { Link } from 'react-router-dom';

const ACCENT = '#1a5fff';

// Renders inline [label](/path) links and **bold** from content strings.
const RichText = ({ text }) => {
  const parts = text.split(/(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      return <Link key={i} to={link[2]} style={{ color: ACCENT, textDecoration: 'underline', textUnderlineOffset: 3 }}>{link[1]}</Link>;
    }
    const bold = part.match(/^\*\*([^*]+)\*\*$/);
    if (bold) return <strong key={i} style={{ color: '#0d1117', fontWeight: 600 }}>{bold[1]}</strong>;
    return part;
  });
};

// Plain-text version for meta tags and JSON-LD.
export const stripRich = (text) => text
  .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
  .replace(/\*\*([^*]+)\*\*/g, '$1');

export default RichText;
